export const ROLE_OPTIONS = [
  { value: 0, label: 'Bogholder' },
  { value: 1, label: 'Administrator' },
  { value: 2, label: 'Bruger' },
];
